import $ from 'jquery';
import {Notif} from "@/js/global/components/Notif";

/**
 * @var grecaptcha
 * @var localizedScript
 */

export const checkoutHandler = async () => {

    const $form = $('#checkout_form');
    if (!$form.length) return;

    $form.on('submit', async function (e) {

        e.preventDefault();

        const $submit = $(this).find('[type="submit"]');

        $submit.prop('disabled', true); // Block from resubmit

        const params = new URLSearchParams(window.location.search);
        const plan = params.get('price_id');

        $('.input-error').text('');
        let hasError = false;

        let requiredFields = [
            { id: '#subscriber_name', err: '#subscriber_name_err' },
            { id: '#subscriber_email', err: '#subscriber_email_err' },
            { id: '#subscriber_phone', err: '#subscriber_phone_err' },
            { id: '#subscriber_password', err: '#subscriber_password_err' },
            { id: '#subscriber_password_confirm', err: '#subscriber_password_confirm_err' }
        ];
        if( localizedScript.is_user_logged_in){
            requiredFields = [
                { id: '#subscriber_name', err: '#subscriber_name_err' },
                { id: '#subscriber_email', err: '#subscriber_email_err' },
                { id: '#subscriber_phone', err: '#subscriber_phone_err' }
            ];
        }

        requiredFields.forEach(field => {
            if (!$(field.id).val()) {
                $(field.err).text('This field is required');
                hasError = true;
            }
        });

        let password = '';
        let passwordConfirm = '';
        if(! localizedScript.is_user_logged_in){
            password = $('#subscriber_password').val();
            passwordConfirm = $('#subscriber_password_confirm').val();
            if (password && passwordConfirm && password !== passwordConfirm) {
                $('#subscriber_password_confirm_err').text('Passwords do not match');
                hasError = true;
            }
        }




        const email = $('#subscriber_email').val();
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            $('#subscriber_email_err').text('Invalid email');
            hasError = true;
        }

        const phone = $('#subscriber_phone').val();
        if (phone && phone.length < 8) {
            $('#subscriber_phone_err').text('Invalid phone');
            hasError = true;
        }

        if (hasError) {
            $submit.prop('disabled', false);
            console.log('Has Error');
            return;
        }

        const firstName = $('#subscriber_name').val();
        const lastName = $('#subscriber_last_name').val();
        /*const $select = $('#subscriber_country');
        const countryCode = $select.val();
        const country  = $select.find('option:selected').text();*/

        //Prepare ajax
        let token = '';
        try {
            token = await grecaptcha.execute(localizedScript.pk, { action: localizedScript.checkout_action });
        } catch (recaptchaErr) {
            Notif.show('error','reCAPTCHA verification failed. Please refresh.');
            $submit.prop('disabled', false);
            return;
        }



        const formData = {
            action: localizedScript.checkout_action,
            nonce: localizedScript.checkout_nonce,
            plan_id: plan,
            recaptcha_token: token,
            subscriber_first_name: firstName,
            subscriber_last_name: lastName,
            subscriber_email: $('#subscriber_email').val(),
            subscriber_phone: $('#subscriber_phone').val(),
            subscriber_password: password,
            //subscriber_street_address: $('#subscriber_street_address').val(),
            //subscriber_street_address_2: $('#subscriber_street_address_2').val(),
            //subscriber_city: $('#subscriber_city').val(),
            //subscriber_state: $('#subscriber_state').val(),
            //subscriber_zip: $('#subscriber_zip').val(),
            //subscriber_company_name: $('#subscriber_company_name').val(),
            //subscriber_country: country,
            //subscriber_country_code: countryCode,
        };
        $submit.addClass('is-loading');
        $.ajax({
            url: localizedScript.ajax_url,
            type: 'POST',
            data: formData,
            success: async function (response) {
                console.log(response);
                $submit.removeClass('is-loading');

                if (response.success && response.data.checkout_url) {
                        // Redirecting directly to Creem secure checkout page
                        window.location.href = response.data.checkout_url;
                } else {
                    const errMsg = response.data?.message || 'Checkout failed. Please check fields.';
                    Notif.show('error',errMsg);
                    $submit.prop('disabled', false);
                }
            },
            error: function (xhr, status, error) {
                Notif.show('error','An unexpected error occurred. Please try again.');
                $submit.prop('disabled', false);
                $submit.removeClass('is-loading');
            }
        });
    });
};